import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { BannersTable, DrawerBanner } from 'widgets/banner';
import { CreateBannerCard } from 'entities/banner';

export const BannersPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Баннеры'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return (
    <>
      <BannersTable />
      <DrawerBanner>
        <CreateBannerCard />
      </DrawerBanner>
    </>
  );
};
